<template>
  <!-- 底部链接 -->
  <div class="bottom-link">
      <div class="g-wrap">
          <div class="left-link">
              网站链接：<span>中国工会网</span><span>南京市工会网</span><span>中国法律援助网</span><span>中国律师网</span>
          </div> 
          <div class="select-box">
              <a-select default-value="工会类链接" style="width: 195px" @change="handleChange">
                <a-select-option value="工会类链接">
                    工会类链接
                </a-select-option>
              </a-select>
              <a-select default-value="主流网站" style="width: 195px" @change="handleChange">
                <a-select-option value="主流网站">
                    主流网站
                </a-select-option>
              </a-select>
              <a-select default-value="其他网站" style="width: 195px" @change="handleChange">
                <a-select-option value="其他网站">
                    其他网站
                </a-select-option>
              </a-select>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'BottomLink',
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
  },
};
</script>
<style scoped>
.bottom-link{
    background: #333333;
    height: 48px;
}
.bottom-link .g-wrap{
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.left-link {
    color: #fff;   
}
.left-link span{
    display: inline-block;
    margin-right: 20px;
}
.select-box .ant-select{
    margin-left: 20px;
}
</style>